<template>
  <dl :class="formType" class="telNo">
    <dt>전화번호</dt>
    <dd class="form">
      <custom-selectbox :value="telNoFrontSelect" :items="telNoFrontList" @custom-select="updateTelNoFront" />
      <span></span>
      <v-input-number v-model="telNoMiddle" @custom-input="updateTelNoMiddle" maxlength="4" />
      <span></span>
      <v-input-number v-model="telNoBack" @custom-input="updateTelNoBack" maxlength="4" />
    </dd>
    <dd v-if="formType == 'modify'" class="bt">
      <v-button @handleClick="cancelClick" class="btn22" text="수정 취소" />
      <v-button @handleClick="submitClick" class="btn21" text="수정 완료" :disabled="this.request.telNo === ''" />
    </dd>
  </dl>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInput from '@/components/atoms/VInput';
import VInputNumber from '@/components/atoms/VInputNumber';
import CustomSelectbox from '@/components/atoms/CustomSelectbox';
import VButton from '@/components/atoms/VButton';

export default {
  components: {
    VInput,
    VInputNumber,
    CustomSelectbox,
    VButton,
  },
  props: {
    formType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      telNoFrontSelect: 0,
      telNoFront: '010',
      telNoMiddle: '',
      telNoBack: '',
      request: {
        telNo: '',
      },
    };
  },
  computed: {
    ...mapGetters(['telNoFrontList']),
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    ...mapActions('userInfo', ['setModifyBusinessTelno']),
    updateTelNoFront(val) {
      this.telNoFrontSelect = val;
      this.telNoFront = this.telNoFrontList[val];
      this.updateTel();
    },
    updateTelNoMiddle(val) {
      this.telNoMiddle = val;
      this.updateTel();
    },
    updateTelNoBack(val) {
      this.telNoBack = val;
      this.updateTel();
    },
    updateTel() {
      if (this.telNoMiddle.length == 4 && this.telNoBack.length == 4) {
        this.request.telNo = `${this.telNoFront}-${this.telNoMiddle}-${this.telNoBack}`;
        this.$emit('update', { request: { telNo: this.request.telNo }, isState: true });
      } else {
        this.request.telNo = '';
        this.$emit('update', { isState: false });
      }
    },
    cancelClick() {
      this.$emit('cancel-click');
    },
    async submitClick() {
      const apiReturn = await this.setModifyBusinessTelno({
        ...this.request,
        businessType: this.userInfo.businessType,
      });
      if (apiReturn === 0) {
        this.$emit('cancel-click');
      }
    },
  },
};
</script>
<style lang="scss">
.telNo {
  .form {
    display: flex;
    align-items: center;
  }
}
</style>
